import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { user } from './user.reducer';
import { alert } from './alert.reducer';
import { questions } from './questions.reducer';
import { assessment } from './assessment.reducer';
import { dashboard } from './dashboard.reducer';
import { survey } from './survey.reducer';

const rootReducer = combineReducers({
  authentication,
  user,
  alert,
  questions,
  assessment,
  dashboard,
  survey
});

export default rootReducer;
